import { render, staticRenderFns } from "./ContestTable.vue?vue&type=template&id=422f7068&scoped=true&"
import script from "./ContestTable.vue?vue&type=script&lang=js&"
export * from "./ContestTable.vue?vue&type=script&lang=js&"
import style0 from "./ContestTable.vue?vue&type=style&index=0&id=422f7068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422f7068",
  null
  
)

export default component.exports